<template>
  <div>
    <loading-spinner />
    <div class="row mt-4 my-4">
      <div class="col-8">
        <Header title="Manage Campaigns" />
      </div>
      <div class="col-4 text-right">
        <a
          v-if="canCreateCampaign === 'True'"
          :href="create"
          target="_parent"
          class="btn btn-lg btn-primary px-4 white"
        >
          Create Campaign
        </a>
      </div>
    </div>
    <ul
      v-show="secondaryCampaignType=== 'Email'"
      class="nav nav-tabs"
    >
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'CampaignsAll', query: campaignsQuery }"
        >
          All ({{ campaignsCounts.allCount }})
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'CampaignsDrafts', query: campaignsQuery }"
        >
          Drafts ({{ campaignsCounts.draftCount }})
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'CampaignsTesting', query: campaignsQuery }"
        >
          Testing ({{ campaignsCounts.testingCount }})
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'CampaignsPending', query: campaignsQuery }"
        >
          Pending ({{ campaignsCounts.pendingCount }})
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'CampaignsApproved', query: campaignsQuery }"
        >
          Approved ({{ campaignsCounts.approvedCount }})
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'CampaignsRejected', query: campaignsQuery }"
        >
          Rejected ({{ campaignsCounts.rejectedCount }})
        </router-link>
      </li>
      <li
        v-show="primary"
        class="nav-item"
      >
        <router-link
          class="nav-link"
          :to="{name: 'CampaignsSent', query: campaignsQuery }"
        >
          Sent ({{ campaignsCounts.sentCount }})
        </router-link>
      </li>
    </ul>
    <ul
      v-show="secondaryCampaignType=== 'Messaging'"
      class="nav nav-tabs"
    >
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'messagingAllPlatforms', query: campaignsQuery }"
        >
          All ({{ MessagingCampaignsCounts.allCount }})
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'CampaignsMessagingDrafts', query: campaignsQuery }"
        >
          Drafts ({{ MessagingCampaignsCounts.draftCount }})
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'CampaignsMessagingPending', query: campaignsQuery }"
        >
          Pending ({{ MessagingCampaignsCounts.pendingCount }})
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'CampaignsMessagingApproved', query: campaignsQuery }"
        >
          Approved ({{ MessagingCampaignsCounts.approvedCount }})
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'CampaignsMessagingRejected', query: campaignsQuery }"
        >
          Rejected ({{ MessagingCampaignsCounts.rejectedCount }})
        </router-link>
      </li>
      <!--<li class="nav-item">
      <router-link
        class="nav-link"
        :to="{name: 'CampaignsMessagingSent', query: campaignsQuery }"
      >
        Sent ({{ MessagingCampaignsCounts.sentCount }})
      </router-link>
    </li>-->
    </ul>
    <div class="row">
      <div class="col-12">
        <div class="row  mt-4">
          <div class="col dropdown-filters-width">
            <div class="form-group mb-0">
              <select
                id="b2b-type-dropdown"
                v-model="b2bKey"
                class="form-control text-truncate"
                style="height: 3rem"
                :disabled="!getHasSalesStatus"
                @change="changeB2BType($event)"
              >
                <option value="Consumer">
                  Consumer
                </option>
                <option value="Sales">
                  Sales
                </option>
              </select>
            </div>
          </div>
          <div class="col dropdown-filters-width">
            <div
              v-if="b2bKey === 'Consumer'"
              class="form-group mb-0"
            >
              <select
                id="campaign-type-dropdown"
                v-model="campaignKey"
                class="form-control text-truncate"
                :disabled="!getSMSMessaging && !getWhatsAppMessaging"
                style="height: 3rem"
                @change="changeCampaignType($event)"
              >
                <option value="Email">
                  Email
                </option>
                <option value="Messaging">
                  Messaging
                </option>
              </select>
            </div>
          </div>
          <div class="col dropdown-filters-width">
            <div
              v-if="b2bKey === 'Consumer'"
              class="form-group mb-0"
            >
              <select
                v-if="campaignKey === 'Email'"
                id="campaign-type-dropdown"
                v-model="emailDropdownKey"
                class="form-control text-truncate"
                :disabled="false"
                style="height: 3rem"
                @change="changeEmailCampaignType()"
              >
                <option value="Marketing">
                  Marketing
                </option>
                <option
                  v-if="getTransactionalMailingInTestMode.settingValue === &quot;0&quot;"
                  value="Transactional"
                >
                  Transactional
                </option>
                <option
                  v-if="getTransactionalMailingInTestMode.settingValue === &quot;1&quot;"
                  value="Transactional"
                >
                  Transactional - In Testing
                </option>
              </select>
              <select
                v-if="campaignKey === 'Messaging'"
                id="campaign-type-dropdown"
                v-model="smsDropdownKey"
                class="form-control  text-truncate"
                :disabled="false"
                style="height: 3rem"
                @change="changeSMSCampaignType()"
              >
                <option
                  v-if="getSMSMessaging && getWhatsAppMessaging"
                  value="AllPlatforms"
                >
                  All Platforms
                </option>
                <option
                  v-if="getSMSMessaging"
                  value="SMS"
                >
                  SMS
                </option>
                <option
                  v-if="getWhatsAppMessaging"
                  value="Whatsapp"
                >
                  Whatsapp
                </option>
              </select>
            </div>
          </div>
          <div
            v-if="campaignKey === 'Email' && b2bKey === 'Consumer'"
            class="col dropdown-filters-width"
          >
            <div
              v-if="getCampaignJourney && getCampaignJourney.settingValue === &quot;Y&quot;"
              class="form-group mb-0"
            >
              <select
                id="campaign-type"
                v-model="primary"
                class="form-control text-truncate"
                style="height: 3rem"
                :disabled="isTransactional || $route.name === 'CampaignsSent'"
                @change="campaignTypeChange()"
              >
                <option
                  v-for="option in options"
                  :key="option.index"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import { mapState, mapGetters } from 'vuex'
import LoadingSpinner from '../components/LoadingSpinner'
import eInsightUrl from '../constants/eInsightUrl'

export default {
  components: {
    Header,
    LoadingSpinner
  },
  data () {
    return {
      primary: true,
      options: [
        { text: 'Primary', value: true },
        { text: 'Sub', value: false }
      ],
      campaignsQuery: {
        clientId: this.$route.query.clientId,
        companyId: this.$route.query.companyId,
        userEmail: this.$route.query.userEmail
        // canCreateCampaign: this.$route.query.canCreateCampaign
      },
      eInsightUrl: {},
      campaignKey: 'Email',
      b2bKey: '',
      emailDropdownKey: '',
      smsDropdownKey: 'AllPlatforms'
    }
  },
  computed: {
    ...mapState({
      campaignsCounts: state => state.manageCampaigns.campaignsCounts,
      MessagingCampaignsCounts: state => state.manageCampaigns.messagingCampaignsCounts,
      isTransactional: state => state.manageCampaigns.isTransactional,
      isPrimary: state => state.manageCampaigns.isPrimary,
      clientId: state => state.manageCampaigns.clientId,
      companyId: state => state.manageCampaigns.companyId,
      canCreateCampaign: state => state.manageCampaigns.canCreateCampaign,
      messagingChannel: state => state.manageCampaigns.messagingChannel,
      b2bCampaignType: state => state.manageCampaigns.b2bCampaignType,
      emailCampaignType: state => state.manageCampaigns.emailCampaignType,
      secondaryCampaignType: state => state.manageCampaigns.secondaryCampaignKey
    }),
    ...mapGetters([
      'getPrimaryCampaigns',
      'getSubCampaigns',
      'getCurrentCompanyId',
      'getCampaignJourney',
      'getTransactionalMailingInTestMode',
      'getHasEmailContentApproval',
      'getSMSMessaging',
      'getWhatsAppMessaging',
      'getHasSalesStatus'
    ]),
    create () {
      return this.$store.getters.getEinsightUri + eInsightUrl.create(this.$route.query.companyId)
    }
  },
  watch: {
    companyId (val) {
      if (val && val.toString() !== this.$route.query.companyId) {
        this.$store.dispatch('setCampaignsByPage', { companyId: val, isPrimary: this.primary, userEmail: atob(this.$route.query.userEmail) })
      }
    },
    emailCampaignType (val) {
      if (val) {
        this.emailDropdownKey = val
      }
    },
    isPrimary (val) {
      if (val) {
        this.primary = val
      }
    }
  },
  beforeMount () {
    // If the secondaryCampaignType has changed and does not match with campaignKey. Setting the campaignKey value to the new secondaryCampaignType
    // Doing this incase we reroute back to the grid view from details page and keep dropdown to correct value
    if (this.campaignKey !== this.secondaryCampaignType) {
      this.campaignKey = this.secondaryCampaignType
    }
  },
  mounted () {
    this.b2bKey = this.b2bCampaignType
    this.emailDropdownKey = this.emailCampaignType
    this.primary = this.isPrimary
    this.$store.dispatch('setParentCompanySetting', { settings: 'TimeZoneFeatureEnabled', email: atob(this.$route.query.userEmail) })
    // this.$store.dispatch('setMessagingCompanySetting', { clientId: this.$route.query.clientId, email: atob(this.$route.query.userEmail) })
    this.$store.dispatch('setSalesCompanySetting', { clientId: this.$route.query.clientId, email: atob(this.$route.query.userEmail) })
  },
  methods: {
    setIsTransactional (value) {
      this.$store.commit('SET_ISTRANSACTIONAL', value)
      if (value === true && this.primary === false) {
        this.primary = true
        this.campaignTypeChange()
      }
    },
    campaignTypeChange () {
      this.$store.commit('SET_ISPRIMARY', this.primary)
      if (this.primary !== true) {
        if (this.getSubCampaigns.length === 0) {
          this.$store.dispatch('setCampaignsByPage', { companyId: this.$route.query.companyId, isPrimary: this.primary, userEmail: atob(this.$route.query.userEmail) })
        } else {
          this.$store.commit('SET_CAMPAIGNS', this.getSubCampaigns)
        }
        if (this.$route.name === 'CampaignsSent') {
          this.$router.push({ name: 'CampaignsAll', query: this.campaignsQuery }).catch(error => {
            if (error.name !== 'NavigationDuplicated') {
              throw error
            }
          })
        }
      } else {
        this.$store.commit('SET_CAMPAIGNS', this.getPrimaryCampaigns)
      }
    },
    changeCampaignType () {
      this.$store.commit('SET_SECONDARY_CAMPAIGN_TYPE', this.campaignKey)
      if (this.campaignKey === 'Messaging') {
        if (this.getSMSMessaging && this.getWhatsAppMessaging) {
          this.smsDropdownKey = 'AllPlatforms'
        } else if (this.getSMSMessaging) {
          this.smsDropdownKey = 'SMS'
        } else {
          this.smsDropdownKey = 'Whatsapp'
        }

        this.$router.push({ name: 'messagingAllPlatforms', query: this.campaignsQuery })
        if (this.smsDropdownKey === 'AllPlatforms') {
          this.$store.commit('SET_MESSAGING_CHANNEL', 'all')
        }
        if (this.smsDropdownKey === 'SMS') {
          this.$store.commit('SET_MESSAGING_CHANNEL', 'sms')
          // this.$router.push({ name: 'messagingSMS', query: this.campaignsQuery })
        }
        if (this.smsDropdownKey === 'Whatsapp') {
          this.$store.commit('SET_MESSAGING_CHANNEL', 'whatsapp')
          // this.$router.push({ name: 'messagingWhatsApp', query: this.campaignsQuery })
        }
      }
      if (this.campaignKey === 'Email') {
        this.$router.push({ name: 'CampaignsAll', query: this.campaignsQuery }).catch(error => {
          if (error.name !== 'NavigationDuplicated') {
            throw error
          }
        })
      }
    },
    changeB2BType (event) {
      // resetting the Email/Messaging dropdown to Email if user switches between consumer and sales
      this.$store.commit('SET_SECONDARY_CAMPAIGN_TYPE', 'Email')
      if (this.b2bKey === 'Consumer') {
        this.campaignKey = 'Email'
        this.$store.commit('SET_B2B_CAMPAIGN_TYPE', 'Consumer')
        this.$router.push({ name: 'CampaignsAll', query: this.campaignsQuery }).catch(error => {
          if (error.name !== 'NavigationDuplicated') {
            throw error
          }
        })
        this.$store.dispatch('setCampaignsByPage', { companyId: this.$route.query.companyId, isPrimary: this.primary, userEmail: atob(this.$route.query.userEmail) })
        this.$store.dispatch('setCampaignsCountsByState', {
          companyId: this.$route.query.companyId,
          isTransactional: this.isTransactional,
          isPrimary: this.isPrimary,
          userEmail: atob(this.$route.query.userEmail),
          sales: this.b2bCampaignType === 'Sales'
        })
      }
      if (this.b2bKey === 'Sales') {
        const getPrimary = true
        const getEmailStatus = 'Marketing'
        this.$store.commit('SET_ISTRANSACTIONAL', false)
        this.$store.commit('SET_ISPRIMARY', getPrimary)
        this.$store.commit('SET_EMAIL_CAMPAIGN_TYPE', getEmailStatus)
        this.$store.commit('SET_B2B_CAMPAIGN_TYPE', 'Sales')
        this.$router.push({ name: 'CampaignsAll', query: this.campaignsQuery }).catch(error => {
          if (error.name !== 'NavigationDuplicated') {
            throw error
          }
        })
        this.$store.dispatch('setCampaignsByPage', { companyId: this.$route.query.companyId, isPrimary: this.primary, userEmail: atob(this.$route.query.userEmail) })
        this.$store.dispatch('setCampaignsCountsByState', {
          companyId: this.$route.query.companyId,
          isTransactional: this.isTransactional,
          isPrimary: this.isPrimary,
          userEmail: atob(this.$route.query.userEmail),
          sales: this.b2bCampaignType === 'Sales'
        })
      }
    },
    changeEmailCampaignType () {
      this.$store.commit('SET_EMAIL_CAMPAIGN_TYPE', this.emailDropdownKey)
      if (this.emailDropdownKey === 'Marketing') {
        this.setIsTransactional(false)
      }
      if (this.emailDropdownKey === 'Transactional') {
        this.setIsTransactional(true)
      }
    },
    changeSMSCampaignType () {
      // Clearing previous filtered values on grid
      this.$root.$emit('updateColumnFilterColors')
      if (this.smsDropdownKey === 'AllPlatforms') {
        this.$store.commit('SET_MESSAGING_CHANNEL', 'all')
        // this.$router.push({ name: 'messagingAllPlatforms', query: this.campaignsQuery })
      }
      if (this.smsDropdownKey === 'SMS') {
        this.$store.commit('SET_MESSAGING_CHANNEL', 'sms')
        // this.$router.push({ name: 'messagingSMS', query: this.campaignsQuery })
      }
      if (this.smsDropdownKey === 'Whatsapp') {
        this.$store.commit('SET_MESSAGING_CHANNEL', 'whatsapp')
        // this.$router.push({ name: 'messagingWhatsApp', query: this.campaignsQuery })
      }
      const campaignStatusList = {
        messagingAllPlatforms: 'all',
        CampaignsMessagingDrafts: 'draft',
        CampaignsMessagingPending: 'pending',
        CampaignsMessagingApproved: 'approved',
        CampaignsMessagingRejected: 'rejected',
        CampaignsMessagingSent: 'sent'
      }
      this.$store.dispatch('setMessagingCampaignsByPage', {
        companyId: this.$route.query.companyId,
        campaignStatus: campaignStatusList[this.$route.name],
        channel: this.messagingChannel,
        userEmail: atob(this.$route.query.userEmail)
      })
      this.$store.dispatch('setMessagingCampaignsCountsByState', {
        companyId: this.$route.query.companyId,
        channel: this.messagingChannel,
        userEmail: atob(this.$route.query.userEmail)
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.campaign-type {
  display: flex;
  width: 120px;
  float: right;
  top: 45px;
  label {
    vertical-align: middle;
    line-height: 30px;
  }
}
.btn-chip {
  @include border-radius(20px);
}
#campaign-type {
  margin-left: 5px;
}
.nav-tabs {
  margin-top: 20px;
}
.white, .white:hover{
  color: white;
}
.dropdown-filters-width{
  max-width: 16rem;
}
</style>
